import React, { Component } from 'react';
import { Grid, Form, Button, Segment, Divider } from 'semantic-ui-react';
import { getPastSubmission, getBatchDetails, exportXLSX } from '../../utils/rest';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import ReactTable from 'react-table';
import MessageBox from '../../ui/MessageBox';
import Loading from '../Loading';

const initialState = {
    acsBatchId: "",
    acsLastName: "",
    acsFirstName: "",
    acsInvoiceId: "",
    acsFrom: "",
    acsTo: "",
    acsSubmittedBy: ""
}
class ViewPastSubmission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchIndex: initialState,
            submissions: [],
            open: false,
            batchList: [],
            submittedByList: [],
            errorOpen: false,
            loading: false
        };
    }

    componentDidMount() {
        this.props.addItem("helpFile", "am_view-past-submissions.md");
        this.getBatchList();
        this.getBatchList({ listUser: true })
    }

    componentDidUpdate(prevProps) {
        if (this.props.items.currentCorporate !== prevProps.items.currentCorporate) {
            this.getBatchList();
            this.getBatchList({ listUser: true })
        }
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    getBatchList = (params) => {
        this.setState({
            loading: true
        }, () => {
            getBatchDetails(this.props.items.currentCorporate, params).then((response) => {
                if (response instanceof Array) {
                    let list = response.map((batch) => {
                        return {
                            value: batch.id,
                            text: batch.name,
                            key: batch.id
                        }
                    });
                    if (params != null && params.listUser) {
                        this.setState({
                            searchIndex: initialState,
                            submittedByList: list
                        })
                    } else {
                        this.setState({
                            searchIndex: initialState,
                            batchList: list
                        })
                    }
                    this.setState({
                        loading: false
                    });
                }
            }).then(() => {
                this.setState({
                    loading: false
                });
            });
        });
    }

    handleChange = (evt, e) => {
        this.setState({
            searchIndex: {
                ...this.state.searchIndex,
                [e.name]: e.value
            }
        })
    }

    searchAccounts = () => {
        this.setState({
            searchIndex: {
                ...this.state.searchIndex,
                acsBatchId: ""
            },
            loading: true
        }, () => {
            if (this.checkEmpty(this.state.searchIndex, ["acsBatchId"])) {
                getPastSubmission(this.props.items.currentCorporate, this.state.searchIndex).then((response) => {
                    if (response !== null) {
                        this.setState({
                            submissions: response,
                            loading: false
                        })
                    }
                }).then(() => {
                    this.setState({
                        loading: false
                    })
                })
            } else {
                this.setState({
                    errorOpen: true,
                    loading: false
                })
            }
        });

    }

    searchBatch = () => {
        if (this.state.batch !== "") {
            this.setState({
                searchIndex: {
                    ...this.state.searchIndex,
                    acsLastName: "",
                    acsFirstName: "",
                    acsInvoiceId: "",
                    acsFrom: "",
                    acsTo: "",
                    acsSubmittedBy: ""
                },
                loading: true
            }, () => {
                getPastSubmission(this.props.items.currentCorporate, this.state.searchIndex).then((response) => {
                    if (response !== null) {
                        this.setState({
                            submissions: response,
                            loading: false
                        })
                    }
                }).then(() => {
                    this.setState({
                        loading: false
                    })
                })
            });
        }
    }

    checkEmpty = (searchIndex, except) => {
        let r = false;
        for (let search in searchIndex) {
            if (searchIndex[search].toString().length > 0 && except.indexOf(search) === -1) {
                r = true;
                break;
            }
        }
        return r;
    }

    close = () => {
        this.setState((prevState, props) => {
            return { errorOpen: false };
        });
    }
    render() {
        return (
            <div>
                {(this.state.loading) ? <Loading /> : ""}
                <BreadcrumbCustom {...this.props} parent="Account Management" child={[{ name: "View Past Submissions", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Form>
                                <Form.Group>
                                    <Form.Field width={6} >
                                        <Form.Select label="Batch:" placeholder="Select" options={this.state.batchList} name="acsBatchId" value={this.state.searchIndex.acsBatchId} onChange={this.handleChange}>
                                        </Form.Select>
                                    </Form.Field>
                                    <Form.Field>
                                        <Button.Group width={4} className="small push-down">
                                            <Button onClick={this.searchBatch} disabled={this.state.searchIndex.acsBatchId !== "" ? false : true} >View Batch</Button>
                                        </Button.Group>
                                    </Form.Field>
                                </Form.Group>
                                <Divider horizontal>OR</Divider>
                                <Form.Group>
                                    <Form.Input label='Start Date:' placeholder='' type="date" width={3} name="acsFrom" value={this.state.searchIndex.acsFrom} onChange={this.handleChange} />
                                    <Form.Input label='End Date:' placeholder='' type="date" width={3} name="acsTo" value={this.state.searchIndex.acsTo} onChange={this.handleChange} />
                                    <Form.Input label={this.props.t("client.account")+":"} placeholder='Your Account Number' width={3} name="acsInvoiceId" value={this.state.searchIndex.acsInvoiceId} onChange={this.handleChange} />
                                    <Form.Select width={4} label="Submitted by:" placeholder="Select" options={this.state.submittedByList} name="acsSubmittedBy" value={this.state.searchIndex.acsSubmittedBy} onChange={this.handleChange}>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Input label='First Name:' placeholder='First Name' width={4} name="acsFirstName" value={this.state.searchIndex.acsFirstName} onChange={this.handleChange} />
                                    <Form.Input label='Last Name:' placeholder='Last Name' width={4} name="acsLastName" value={this.state.searchIndex.acsLastName} onChange={this.handleChange} />
                                    <Button.Group width={8} className="left small buttons push-down">
                                        <Button onClick={this.searchAccounts}>View Accounts</Button>
                                    </Button.Group>
                                </Form.Group>
                            </Form>
                            <Segment.Group>
                                <Segment raised color="grey" inverted>
                                    <h4 className="ui header">
                                        <i className="folder open icon"></i>
                                        <div className="content">
                                            View Past Submmission
                                            </div>
                                        <div className="right floated content push-up small-font">

                                        </div>
                                    </h4>
                                </Segment>
                                <Grid className="margin-bottom-5">                                   
                                    <Grid.Column width={1} floated='right' className="remvespace-btm">
                                        <Button onClick={() => { exportXLSX(
                                            { "Client Id": "acsClientId", 
                                              "Client Acct#": "acsInvoiceId", 
                                              "Consumer's Last Name": "acsLastName", 
                                              "Consumer's First Name": "acsFirstName", 
                                              "FOR": "acsAccountFor",                                               
                                              "SSN": "acsSsn",
                                              "DLP": "acsDateOfLastPayment", 
                                              "DOS": "acsDateOfSubmission", 
                                              "DOB": "acsDob",                                               
                                              "PB": "acsPrincipal",
                                              "INT": "acsInterest", 
                                              "Fees": "acsOtherCharges", 
                                              "Currency Code": "acsCurrencyCode", 
                                              "Total": "acsTotal"
                                              
                                              }, this.state.submissions,"ViewPastSubmission.xlsx") }} 
                                        className="ui left small icon button icon-export" data-inverted="" data-tooltip="Export Table Details to Spreadsheet" data-position="bottom right">
                                            <i className="file excel icon"></i>
                                        </Button>
                                    </Grid.Column>
                                </Grid>
                                <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.state.submissions && this.state.submissions.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                                    data={this.state.submissions}
                                    getNoDataProps={() => {
                                        return { style: { maxWidth: 100, display: 'none' } };
                                    }}
                                    getTableProps={() => {
                                        return { className: "fluid" };
                                    }}
                                    columns={[{
                                        Header: "#",
                                        width: 50,
                                        filterable: false,
                                        Cell: (row) => {
                                            return <div>{row.index + 1}</div>;
                                        }
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Our Client Identifier" data-position="bottom left">Client ID</span>,
                                        accessor: 'acsClientId',
                                        width: 100,
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Your Account Number for this Billing" data-position="bottom left">Client Acct#</span>,
                                        accessor: 'acsInvoiceId',
                                        width: 100,

                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Consumer’s Last Name" data-position="bottom left">{this.props.t("lastname")}</span>,
                                        accessor: 'acsLastName'

                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Consumer’s first Name" data-position="bottom left">{this.props.t("firstname")}</span>,
                                        accessor: 'acsFirstName',

                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Services Provided" data-position="bottom left">For</span>,
                                        accessor: 'acsAccountFor',
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Consumer’s Social Security Number" data-position="bottom left">SSN</span>,
                                        id: 'acsSsn',
                                        width: 90,
                                        accessor: row => (
                                            this.props._padString(row.acsSsn.toString())
                                        )
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Date of Last Payment" data-position="bottom left">DLP</span>,
                                        id: 'acsDateOfLastPayment',
                                        width: 100,
                                        accessor: row => (
                                            this.props._formatDate(row.acsDateOfLastPayment)
                                        )
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Date of Service" data-position="bottom left">DOS</span>,
                                        id: 'acsDateOfSubmission',
                                        width: 100,
                                        accessor: row => (
                                            this.props._formatDate(row.acsDateOfSubmission)
                                        )
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Consumer’s Date of Birth" data-position="bottom left">DOB</span>,
                                        id: 'acsDob',
                                        width: 100,
                                        accessor: row => (
                                            this.props._formatDate(row.acsDob)
                                        )
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Principal Balance" data-position="bottom left">PB</span>,
                                        id: 'acsPrincipal',
                                        width: 100,
                                        style: {
                                            textAlign: "right"
                                        },
                                        accessor: row => (
                                            this.props._currencyFormat(row.acsPrincipal)
                                        )
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Interest" data-position="bottom left">INT</span>,
                                        id: 'acsInterest',
                                        width: 100,
                                        style: {
                                            textAlign: "right"
                                        },
                                        accessor: row => (
                                            this.props._currencyFormat(row.acsInterest)
                                        )
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Other Additional Charges" data-position="bottom left">Fees</span>,
                                        id: 'acsOtherCharges',
                                        width: 100,
                                        style: {
                                            textAlign: "right"
                                        },
                                        accessor: row => (
                                            this.props._currencyFormat(row.acsOtherCharges)
                                        )
                                    },{
                                        Header: props => <span data-inverted="" data-tooltip="Account Currency Code" data-position="bottom left">Currency Code</span>,
                                        id: 'acsCurrencyCode',
                                        width: 100,
                                        style: {
                                            textAlign: "center"
                                        },
                                        accessor: row => (
                                            row.acsCurrencyCode
                                        )
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip="Current Total Due" data-position="bottom right">Total</span>,
                                        id: 'acsTotal',
                                        width: 100,
                                        style: {
                                            textAlign: "right"
                                        },
                                        accessor: row => (
                                            this.props._currencyFormat(row.acsTotal)
                                        )
                                    }]}
                                />
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <MessageBox {...this.props} size="mini" box={9} open={this.state.errorOpen} close={this.close} />
            </div>
        );
    }
}
export default ViewPastSubmission;


// WEBPACK FOOTER //
// ./src/app/ui/accounts/ViewPastSubmission.js